import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./Login.module.css"
import guestii from '../../assets/images/logos/guestii.svg'
import banner from '../../assets/images/banner.jpg'
import google from '../../assets/images/google.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'

import { MovingTextContainer } from '../Utils/Helpers'
import GoogleConnect from '../Auth/GoogleConnect'



const LoginPage = ({  }) => {
	const navigate = useNavigate();
	const [formData, setFormData] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const [validationError, setValidationError] = useState(null)


	useEffect(() => {
		if (validationError) {
		  	const timer = setTimeout(() => setValidationError(null), 5000);
		  	return () => clearTimeout(timer);
		}
	}, [validationError]);

	const handleForm = async (control, label, input) => {
		switch (control) {
			case 'set':
				let labelFormatted = label.replaceAll(" ", "_").toLowerCase()

				if (input.target) {
					setFormData((prev) => ({...prev, [labelFormatted]: input.target.value }))
				} else {
					setFormData((prev) => ({...prev, [labelFormatted]: input }))
				}
				break;
			case 'submit':
				setIsLoading(true)

				try {
					const connectResponse = await axios.post(`/api/auth/connect`, formData);
					if (connectResponse.data.verified) {
						localStorage.setItem("_id", connectResponse.data.user._id );
						localStorage.setItem("expiry", connectResponse.data.token)
						window.location = "/hub/" + connectResponse.data.user._id
					}
				} catch (err) {
					if (err.response.data.message === "verify") {
						localStorage.setItem("registerData", JSON.stringify({ _id: err.response.data._id }));
						window.location = "/register"
					} else {
						setValidationError(err.response.data.message)
					}

					setIsLoading(false)
					return false;
				}
				break;
		}
	}

	return (
		<div className={styles.container}>
			<div className={styles.content_container}>
			    {validationError &&
			        <div className={styles.error_banner}>
			          	<p className={styles.error_text}>{validationError}</p>
			        </div>
			    }

				<img src={guestii} className={styles.logo}/>
				<div className={styles.underline}/>

				<div className={styles.login_container}>
					<div className={styles.login_banner_container}>
						<h1>Welcome Back!</h1>
						<p>You were missed</p>
					</div>

					{/* <GoogleConnect/> */}

					<div className={styles.alternate_container}>
						<div className={styles.seperating_line}></div>
						<p className={styles.s1}>Or with email</p>
						<div className={styles.seperating_line}></div>
					</div>

					<div className={styles.login_form}>
						<MovingTextContainer
							label={"Email"}
							icon={"fa-solid fa-envelope"}
							handleForm={handleForm}
							formData={formData}
							classData={{
								location: "rstyles",
								name: "input_container"
							}}
							register={true}
							autofill={true}
						/>

						<MovingTextContainer
							label={"Password"}
							icon={"fa-solid fa-unlock-keyhole"}
							handleForm={handleForm}
							formData={formData}
							classData={{
								location: "rstyles",
								name: "input_container"
							}}
							register={true}
							secondary={true}
							password={true}
							autofill={true}
						/>

						<button className={styles.forgot_password}><p className={styles.s2}>Forgot Password?</p></button>
					</div>


					<button className={isLoading ? styles.login_btn_loading : styles.login_btn} onClick={() => handleForm('submit')} disabled={isLoading}>
						{isLoading
							? <img src={guestii_gif} className={styles.logo_gif}/>
							: <p>Login</p>
						}
					</button>

					{/* <div className={styles.signup_container} onClick={() => navigate('/register')}> */}
					{/* 	<p className={styles.s2}>Not a guestii?&nbsp;</p><button><p className={styles.s2}>Sign up now!</p></button> */}
					{/* </div> */}
				</div>
			</div>

			<div className={styles.banner_container}>
				<h3>Manage your events and guestlists seamlessly</h3>
				<p>Designed to create and manage events and guest lists, offering seamless invitations, role-based permissions, and real-time updates to enhance your event planning experience.</p>

				<div className={styles.circle_grid}>
					<div className={styles.circle}></div>
					<div className={styles.circle}></div>
					<div className={styles.circle}></div>
				</div>

				<img src={banner}/>
			</div>
		</div>
	)
}

const Login = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [isAuthenticated, setIsAuthenticated] = useState(true);

	useEffect(() => {
		const validateExpiry = async () => {
			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")

			if (userId && expiry) {
				window.location = "/hub/" + userId
			}
		}

		validateExpiry()
	}, []);


	return (
		<>			
			{isLoading
				? <Loading />
				:
					<>
						{isAuthenticated
							?
								<LoginPage />
							: <Forbidden />
						}
					</>
			}
		</>
	);
};

export default Login;